import React, { Component, Fragment } from 'react';
import { Button, Input, Modal } from 'antd';
import { connect } from 'react-redux';
import { addNoteRequest } from '../../Lead_profile/redux/actions/add_note.actions';
import { setLeadApproveRequest } from '../redux/actions/set_lead_approve.actions';

const { TextArea } = Input;

class DenyLeadApproveModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: false,
            rejectionReason: '',
        };
    }

    saveRejectionReasonToState = e => this.setState({ rejectionReason: e.target.value });

    showModal = () => this.setState({ visible: true });

    denyApprovalForLead = () => {
        this.props.setLeadApproveRequest({ lead_id: this.props.lead_id, approve_kind: this.props.approve_kind, approve_value: false });
        this.setState({ visible: false });
    };

    handleCancel = () => this.setState({ visible: false });

    render() {
        return (
            <Fragment>
                <Button
                    type="danger"
                    size="small"
                    onClick={this.showModal}
                >
                    Reject
                </Button>
                <Modal
                    title="Rejection Reason"
                    visible={this.state.visible}
                    okText="Confirm"
                    cancelText="Cancel"
                    onOk={this.denyApprovalForLead}
                    okButtonProps={
                        {
                            disabled: !this.state.rejectionReason,
                            type: 'danger',
                        }
                    }
                    onCancel={this.handleCancel}
                >
                    <TextArea
                        style={{ resize: 'none' }}
                        autosize={{ minRows: 2, maxRows: 6 }}
                        placeholder="Please, type a reason of rejection for bike"
                        value={this.state.rejectionReason}
                        onChange={this.saveRejectionReasonToState}
                    />
                </Modal>
            </Fragment>
        );
    }
}

export default connect(null, { setLeadApproveRequest, addNoteRequest })(DenyLeadApproveModal);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_approval/components/DenyLeadApproveModal.js